import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  LabelList,
} from "recharts";

const fmtInt = (n) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Number(n || 0));

const truncate = (s = "", n = 16) => (s.length > n ? s.slice(0, n - 1) + "…" : s);

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;

  const lic = Number(payload.find((p) => p.dataKey === "Licenciés")?.value || 0);
  const ins = Number(payload.find((p) => p.dataKey === "Inscrits")?.value || 0);
  const total = lic + ins;

  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-lg px-3 py-2">
      <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">
        {label}
      </div>
      <div className="mt-1 text-xs text-slate-600 dark:text-slate-300">
        Licenciés : <span className="font-semibold">{fmtInt(lic)}</span>
      </div>
      <div className="mt-1 text-xs text-slate-600 dark:text-slate-300">
        Inscrits : <span className="font-semibold">{fmtInt(ins)}</span>
      </div>
      <div className="mt-1 text-xs text-slate-600 dark:text-slate-300">
        Total : <span className="font-semibold">{fmtInt(total)}</span>
      </div>
    </div>
  );
}

// label total au-dessus (sur la barre du haut)
const TotalLabel = (props) => {
  const { x, y, width, value } = props;
  if (!value) return null;
  return (
    <text x={x + width / 2} y={y - 6} textAnchor="middle" fontSize={12} fontWeight={700}>
      {fmtInt(value)}
    </text>
  );
};

export function MembersStackedBars({ data = [], loading = false }) {
  if (loading) {
    return <div className="h-[280px] rounded-xl bg-slate-100 dark:bg-slate-800 animate-pulse" />;
  }

  if (!data?.length) {
    return (
      <div className="h-[280px] rounded-xl border border-slate-200 dark:border-slate-800 flex items-center justify-center text-slate-500">
        Aucune donnée
      </div>
    );
  }

  const chartData = data.map((d) => ({ ...d, short: truncate(d.name, 16) }));

  return (
    <div className="h-[280px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 16, right: 12, left: 8, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.35} />
          <XAxis dataKey="short" tick={{ fontSize: 12 }} interval={0} />
          <YAxis tick={{ fontSize: 12 }} tickFormatter={(v) => fmtInt(v)} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: 12 }} />

          <Bar dataKey="Licenciés" stackId="a" fill="#5A8DEE"  />
          <Bar dataKey="Inscrits" stackId="a" fill="#FF6A88" radius={[8, 8, 0, 0]}>
            <LabelList dataKey="total" content={TotalLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default MembersStackedBars;
